<template>
  <div class="common-style stratify">
    <div class="topSelect">
      <a-select
        placeholder="请选择班级"
        notFoundContent="暂无班级"
        style="width:200px;margin:0 20px 20px 0"
        v-model="classList.name"
        @select="select"
      >
        <a-select-option v-for="item in classList.list" :key="item.id">{{
          item.name
        }}</a-select-option>
      </a-select>
      <!-- <a-select
      placeholder="请选择学科"
      style="width:200px;margin:0 20px 20px 50px"
      v-model="courseList.value"
      @select="selectCourse"
    >
      <a-select-option v-for="(item,index) in courseList.list" :key="index">{{item}}</a-select-option>
      </a-select>-->
      <a-button @click="addGroup" type="primary">+添加分组</a-button>
      <a-modal
        title="新建分组"
        v-model="visible"
        @ok="handleOk"
        cancelText="取消"
        okText="确认"
      >
        <a-form layout="inline" :form="form">
          <a-form-item label="分组名称">
            <a-input
              placeholder="请输入分组名称"
              style="width: 300px"
              :max-length="30"
              v-decorator="[
                'group',
                { rules: [{ required: true, message: '请输入分组名称!' }] },
              ]"
            />
          </a-form-item>
        </a-form>
      </a-modal>
    </div>
    <a-row style="padding:20px">
      <a-col
        class="col-list"
        :span="5"
        v-for="(item, index) in classGroupList"
        :key="index"
        :data-id="index"
        ref="name"
      >
        <div class="operate">
          <p class="handleP1">{{ item.groupName }}</p>
          <p class="handleP2">
            <a-dropdown :trigger="['click']" v-if="index !== 0">
              <a class="ant-dropdown-link" href="#">
                <a-icon type="ellipsis" style="font-size:16px;" />
              </a>
              <a-menu slot="overlay">
                <a-menu-item>
                  <a @click="editName(item)">修改</a>
                </a-menu-item>
                <a-menu-item>
                  <a @click="confirmDelete(item)">删除</a>
                </a-menu-item>
              </a-menu>
            </a-dropdown>
          </p>
        </div>
        <draggable
          group="people"
          :list="item.studentIdAndName"
          class="draggable"
          @change="getOldGroupId(item.groupId, $event)"
          @remove="onRemove(item)"
        >
          <div
            class="name-list"
            v-for="(item, index) in item.studentIdAndName"
            :key="index"
          >
            {{ item.name }}
          </div>
        </draggable>
      </a-col>
      <!-- </div> -->
    </a-row>
    <a-modal
      title="修改分组名称"
      v-model="visibleEdit"
      @ok="handleEditOk"
      cancelText="取消"
      okText="确认"
    >
      <a-form layout="inline" :form="formModify">
        <a-form-item label="修改分组名称">
          <a-input
            @blur="handleChange"
            style="width:300px"
            :max-length="30"
            v-decorator="[
              'groupName',
              {
                rules: [{ required: true, message: '请输入分组名称!' }],
                initialValue: `${editItem.groupName}`,
              },
            ]"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--  -->
    <div v-if="noData" class="noData" style="margin-top:150px;">
      <p><img src="../../assets/images/noData.png" alt="" /></p>
    </div>
    <!-- 刷新 -->
    <div class="load" v-if="loadingList">
      <a-spin />
    </div>
  </div>
</template>
<script>
import draggable from "vuedraggable"
export default {
  data() {
    return {
      loadingList: true,
      noData: false,
      startArr: [],
      endArr: [],
      count: 0,
      form: this.$form.createForm(this),
      formModify: this.$form.createForm(this),
      classList: {
        list: [],
        value: "",
        name: "",
      },
      courseList: {
        list: [],
        value: "",
        classArr: [],
      },
      editItem: {},
      editValues: {},
      classGroupList: [],
      visible: false,
      detail: {},
      visibleEdit: false,
      groupid: "",
      aftergroupid: "",
      dragName: "",
      dragId: "",
    }
  },
  components: {
    draggable,
  },
  created() {
    this.getClassList()
  },
  methods: {
    // 获取班级
    getClassList() {
      this.$http
        .get("v1/learnonly/cm/StudentManagement/students/list", {
          params: { userid: this.$store.getters.id, typeid: 1 },
        })
        .then((res) => {
          if (res.data.data.classInfo && res.data.data.classInfo.length > 0) {
            this.classList.list = res.data.data.classInfo
            this.classList.value = res.data.data.classInfo[0].id
            this.classList.name = res.data.data.classInfo[0].name
            this.$nextTick(() => {
              this.getClassGroupList()
            })
          } else {
            setTimeout(() => {
              this.loadingList = false
              this.noData = true
            }, 500)
          }
        })
    },
    select(value) {
      this.classList.value = value
      this.getClassGroupList()
    },
    // 获取学科
    getCourseList() {
      this.$http
        .get("v1/learnonly/teachingAssistant/showUserCourse", {
          params: { userid: this.$store.getters.id },
        })
        .then((res) => {
          if (res) {
            this.courseList.list = res.data
            for (var i in res.data) {
              var obj = {}
              obj.id = i
              obj.name = res.data
              this.courseList.classArr.push(obj)
              this.courseList.value = this.courseList.classArr[0].id
            }
            this.$nextTick(() => {
              this.getClassGroupList()
            })
          }
        })
    },
    // selectCourse (value) {
    //     this.courseList.value = value;
    //     this.getClassGroupList();
    // },
    // 获取分组列表
    getClassGroupList() {
      this.$http
        .get("v1/learnonly/cm/StudentManagement/group/showGroups", {
          params: {
            userid: this.$store.getters.id,
            classids: this.classList.value,
          },
        })
        .then((res) => {
          if (res.data.data !== null) {
            this.classGroupList = res.data.data[0].completeGroup
            this.courseList.value = res.data.data[0].completeGroup[0].courseId
            this.loadingList = false
            this.noData = false
          } else {
            this.classGroupList = []
            this.loadingList = false
            this.noData = true
          }
        })
    },
    // 添加分组
    addGroup() {
      this.visible = true
      this.form.resetFields()
    },
    handleOk() {
      let that = this
      if (this.classList.list.length == 0) {
        that.visible = false
        return this.$message.warning("暂未绑定班级!", 1)
      }

      that.form.validateFields((err, values) => {
        if (!err) {
          // console.log("Received values of form: ", values);
          if (values != "") {
            const flag = this.classGroupList.some((item) => {
              return item.groupName === values.group
            })
            if (flag) return this.$message.error("不能重复添加分组")

            this.$http
              .post("v1/learnonly/cm/StudentManagement/group/saveGroup", {
                userid: this.$store.getters.id,
                orgid: this.$store.getters.orgid,
                courseid: this.courseList.value,
                classid: this.classList.value,
                typeid: 1,
                groupid: "",
                groupname: values.group,
              })
              .then((response) => {
                console.log(response)
                that.visible = false
                if (response.data.code != 200)
                  return this.$message.warning(response.data.message, 1)
                that.$message.success(response.data.message)
                that.getClassGroupList()
              })
              .catch(function(error) {
                console.log(error)
              })
          }
        }
      })
    },
    // 修改分组
    editName(item) {
      this.editItem.groupName = item.groupName
      this.groupid = item.groupId
      this.classList.value = item.classId
      this.courseList.value = item.courseId
      this.visibleEdit = true
      this.formModify.resetFields()
    },
    handleChange(e) {
      this.editValues.groupName = e.target.value
    },
    handleEditOk() {
      let that = this
      that.formModify.validateFields((err, values) => {
        if (!err) {
          // console.log("Received values of form: ", values);
          if (values != "") {
            this.$http
              .post("v1/learnonly/cm/StudentManagement/group/saveGroup", {
                userid: that.$store.getters.id,
                orgid: that.$store.getters.orgid,
                courseid: that.courseList.value,
                classid: that.classList.value,
                typeid: 2,
                groupid: that.groupid,
                groupname: that.editValues.groupName || that.editItem.groupName,
              })
              .then(function(response) {
                that.visibleEdit = false
                that.$message.success(response.data.message)
                that.getClassGroupList()
              })
              .catch(function(error) {
                console.log(error)
              })
          }
        }
      })
    },
    // 删除分组
    confirmDelete(item) {
      let that = this
      this.$confirm({
        title: "确认删除 " + item.groupName + " 吗?（删除后组内学生将会自动转入默认分组）",
        okText: "确认",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          that.$http
            .get("v1/learnonly/cm/StudentManagement/group/deleteGroupStudent", {
              params: {
                userid: that.$store.getters.id,
                orgid: that.$store.getters.orgid,
                groupid: item.groupId,
                courseid: item.courseId,
                classid: item.classId,
              },
            })
            .then(function(res) {
              that.$message.success(res.data.message)
              that.getClassGroupList()
            })
            .catch(function(error) {
              console.log(error)
            })
        },
      })
    },
    // 拖拽start
    // 58 59 60
    onRemove(item) {
      this.$http
        .post("v1/learnonly/cm/StudentManagement/group/changeGroup", {
          orgid: this.$store.getters.orgid,
          studentids: this.dragId,
          beforegroupid: item.groupId,
          aftergroupid: this.aftergroupid,
        })
        .then(function(response) {
          console.log(response)
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    getOldGroupId: function(id, event) {
      if (event.added) {
        this.aftergroupid = id
        this.dragId = event.added.element.id
      }
    },
    // 拖拽end
  },
}
</script>
<style scoped>
.topSelect {
  border-bottom: 10px solid #f0f2f5;
  padding: 20px 20px 0 20px;
}
.ant-form-inline .ant-form-item {
  display: inline-block;
  margin-right: 16px;
  margin-bottom: 0;
}

.col-list {
  padding: 10px;
  position: relative;
  margin-right: 20px;
  margin-bottom: 20px;
  border: 1px solid #e1e4e8;
  background-color: #f0f2f5;
  border-radius: 6px;
  height: 300px;
  overflow: auto;
}
.col-list::-webkit-scrollbar {
  width: 0;
}
.col-list a {
  color: rgb(124, 68, 68);
  cursor: pointer;
}
.col-list div {
  cursor: pointer;
}
.ant-modal-body {
  padding: 15px 70px;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
}
.operate {
  overflow: hidden;
}
.operate .handleP1 {
  float: left;
  padding-right: 10px;
  font-weight: 700;
}
.operate .handleP2 {
  float: right;
}
.draggable {
  min-height: 200px;
  line-height: 2;
}
.draggable > .name-list {
  float: left;
  width: 25%;
  min-width: 4em;
  text-align: left;
}
/* 刷新 */
.ant-spin-spinning {
  padding-top: 300px;
  padding-left: 50%;
}
</style>
